import styled from 'styled-components';
import { breakpoints } from '../../../theme';
import { HEADER_HEIGHT, FOOTER_HEIGHT } from '../../../theme/constants';

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  position: relative;
  z-index: 1;
  /* No global background image here */
`;

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: ${HEADER_HEIGHT.desktop};
  padding-bottom: ${FOOTER_HEIGHT};

  @media (max-width: ${breakpoints.tablet}) {
    padding-top: ${HEADER_HEIGHT.tablet};
    padding-bottom: ${FOOTER_HEIGHT};
  }
`;

export const MainContent = styled.main`
  width: 100%;
  position: relative;
  z-index: 1;
  /* Optional: a semi-transparent overlay if needed, else remove it */

`;
